import {
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  ViewChild,
  ChangeDetectionStrategy,
  ChangeDetectorRef
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ConfirmationService } from '@app/library';
import { AuthService } from '@app/shared';
import { NavList } from '@entity/navigation';
import { RoleFilterPipe } from './role.pipe';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
  providers: [RoleFilterPipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavigationComponent implements OnInit {
  navLists: NavList[];
  menuState = 'out';
  isClosed = false;
  @ViewChild('menuBtn') menuBtn: ElementRef;
  @ViewChild('wrapper') wrapper: ElementRef;
  roleId: any;
  isArchiveFlag: string;
  hostNameUrl: any;
  associatedId: any;

  constructor(
    public auth: AuthService,
    private renderer: Renderer2,
    private router: Router,
    private pop: ConfirmationService,
    private rolePipe: RoleFilterPipe,
    private _cdr: ChangeDetectorRef,
    //    private service: NavService
    private http: HttpClient
  ) { }

  ngOnInit() {
    // this.navLists = this.rolePipe.transform(this.auth.navListData);
    //console.log(this.navLists); 
    this.isArchiveFlag = this.auth.getDomainName();
    this.roleId = this.auth.loginData.RoleId;
    this.hostNameUrl = this.auth.hostName;
    this.associatedId = btoa(this.auth.loginData.AssociatedId);
    this.getMenuList();

    // this.router.events.subscribe(event => {
    //   if (event instanceof NavigationEnd) {
    //     this.isClosed = true;
    //     this.toggleMenu(true);
    //   }
    // });
  }

  getMenuList() {
    let param = { roleId: this.roleId, isArchiveFlag: this.isArchiveFlag };
    this.http.post('menu', param).subscribe((res: any) => {
      this.navLists = this.rolePipe.transform(res.data);
      // this.navLists = res.data;
    });
  }

  menuClicked() {
    this.isClosed = true;
    this.toggleMenu(true);
  }

  logout() {
    //logout the user from other devices.(restricting concurrent logins)..
    this.auth.logoutApi().subscribe((res:any) => {
      if (res.Status.toLowerCase() == "success") {
        this._cdr.detach();
        this.auth.logout();
      }
    });
  }

  toggleMenu(byNav?: boolean) {
    this.menuState = byNav ? 'out' : this.menuState === 'out' ? 'in' : 'out';
    this.hamburger_cross();
  }

  hamburger_cross() {
    if (this.isClosed === true) {
      this.wrapper?.nativeElement?.classList?.toggle('fade-in');
      this.renderer?.removeClass(this.wrapper?.nativeElement, 'toggled');
      this.renderer?.removeClass(this.menuBtn?.nativeElement, 'is-open');
      this.renderer?.addClass(this.menuBtn?.nativeElement, 'is-closed');
      this.isClosed = false;
    } else {
      this.renderer?.removeClass(this.menuBtn?.nativeElement, 'is-closed');
      this.renderer?.addClass(this.menuBtn?.nativeElement, 'is-open');
      this.wrapper?.nativeElement?.classList?.toggle('toggled');
      this.isClosed = true;
    }
    this._cdr.detectChanges();
  }

  clearStorage() {
    sessionStorage.removeItem("paginate-Enquiry");
  }
}
